import * as yup from 'yup';

export const schema = yup.object({
  cod_ibs_cbs: yup
    .object({
      value: yup.number().required(),
      label: yup.string().required(),
    })
    .required(),
});
